import { UnifiedTeamBrowser } from "./UnifiedTeamBrowser"

export function EnhancedTeamBrowser() {
  return <UnifiedTeamBrowser />
}